import GVSelect from 'components/lib/GVSelect/GVSelect';
import { brailleLanguageList } from '@verify/shared-utils';
import { useDispatch, useSelector } from 'react-redux';
import { getInspectionSettings, inspection } from 'store';
import styles from './BrailleLanguageSelect.module.css';

const BrailleLanguageSelect = () => {
  const dispatch = useDispatch();
  const settings = useSelector(getInspectionSettings);

  const handleBrailleLanguageChange = (brailleLanguage: string) => {
    dispatch(inspection.actions.setInspectionSettings({ brailleLanguage }));
  };

  return (
    <GVSelect
      defaultValue={settings?.brailleLanguage || 'English'}
      onValueChange={handleBrailleLanguageChange}
      label="Braille Language"
      options={brailleLanguageList}
      id="braille-language-input"
      contentClassName={styles.select}
    />
  );
};

export default BrailleLanguageSelect;
